import(/* webpackMode: "eager", webpackExports: ["CapabilityDetail"] */ "C:\\sites\\enginuity\\components\\pages.jsx");
